import React from "react";
import { useSelector } from "react-redux";

const SortIcon = () => {
  const treeDataRed = useSelector((state) => state.treeDataRed);
  if (treeDataRed.sortType === "a-z")
    return <i className="bi bi-sort-alpha-down sort-icon"></i>;
  if (treeDataRed.sortType === "z-a")
    return <i className="bi bi-sort-alpha-down-alt sort-icon"></i>;
  if (treeDataRed.sortType === "dateAsc")
    return <i className="bi bi-sort-numeric-down sort-icon"></i>;
  if (treeDataRed.sortType === "dateDesc")
    return <i className="bi bi-sort-numeric-down-alt sort-icon"></i>;

  return <i class="bi bi-arrow-down-up sort-icon"></i>;
};

export default SortIcon;
